module.exports = __webpack_public_path__ + "img/business-planIcon.3ffa055b.svg";